import { useState, useEffect } from 'react';
import { useAuthActions } from '@convex-dev/auth/react';
import { Button } from '@/components/ui/button';
import { RefreshCw, LogOut } from 'lucide-react';

const LOADING_TIMEOUT = 10000; // 10 seconds

export const FullPageLoading = () => {
  const [showActions, setShowActions] = useState(false);
  const authActions = useAuthActions();
  const signOut = authActions?.signOut;

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowActions(true);
    }, LOADING_TIMEOUT);

    return () => clearTimeout(timer);
  }, []);

  const handleReload = () => {
    window.location.reload();
  };

  const handleLogout = async () => {
    try {
      if (signOut) {
        await signOut();
      }
    } catch (error) {
      console.error('Logout failed:', error);
    } finally {
      window.location.reload();
    }
  };

  return (
    <div className="flex items-center justify-center h-screen">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500 mx-auto mb-4"></div>
        <p className="text-gray-600 mb-6">Loading your tasks...</p>
        
        {showActions && (
          <div className="space-y-4 animate-in fade-in duration-500">
            <p className="text-sm text-muted-foreground mb-4">
              This is taking longer than expected
            </p>
            <div className="flex flex-col gap-2 max-w-xs mx-auto">
              <Button
                onClick={handleReload}
                variant="outline"
                size="sm"
                className="w-full"
              >
                <RefreshCw className="mr-2 h-4 w-4" />
                Reload Page
              </Button>
              <Button
                onClick={() => void handleLogout()}
                variant="outline"
                size="sm"
                className="w-full"
              >
                <LogOut className="mr-2 h-4 w-4" />
                Sign Out
              </Button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
